/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：688__part-0
 */

"use strict"

var r = {
  "zh-CN": {
    widgetNameMsg: "识别二维码",
    scanMsg: "进行扫码",
    scanImageMsg: "识别图片",
    imageMsg: "",
    onScanSuccessMsg: "识别成功",
    onScanErrorMsg: "识别失败",
    contentMsg: "识别结果",
    errorMsg: "失败原因"
  }
}
export { r }
